"use client";

import { useFormStatus } from "react-dom";
import { Button } from "./Button";
import type { ComponentProps } from "react";

type Variant = "primary" | "secondary" | "danger" | "ghost" | "outline" | "ai";

/**
 * A submit button that shows a spinner + "ing" label while the
 * parent form's server action is pending. Use inside forms that
 * use server actions — safer than a bare <Button type="submit">
 * because the user gets feedback the click was received.
 */
export function SubmitButton({
  children,
  pendingLabel,
  ...props
}: ComponentProps<typeof Button> & {
  pendingLabel?: string;
  variant?: Variant;
}) {
  const { pending } = useFormStatus();
  return (
    <Button type="submit" loading={pending} disabled={pending} {...props}>
      {pending ? (pendingLabel ?? "Saving…") : children}
    </Button>
  );
}
